import { Theme } from '@mui/system'
import { makeStyles } from '@mui/styles'

interface IProps {
  isInputLable?: boolean
  verticalPosition?: number
  size?: number
}

export const useStyles = makeStyles((theme: Theme) => ({
  wrapper: {
    position: 'relative',
    display: 'inline-block',
  },
  tooltip: (props: IProps) => ({
    '&&': {
      position: 'absolute',
      top: 0,
      right: 0,
      transform: props.isInputLable
        ? 'translate(120%, 15%)'
        : props.verticalPosition || props.verticalPosition === 0
          ? `translate(120%, ${props.verticalPosition}%)`
          : 'translate(120%, 30%)',
      fontSize:
        props.size || props.size === 0
          ? `${props.size}px`
          : props.isInputLable
            ? '11px'
            : '0.875rem',
    },
  }),
}))
